export default __webpack_public_path__ + "static/media/dr-nisha.636148fe.jpg";